export type Lang = 'zh' | 'en' | 'zh_tw'

export interface I18nKey {
  [key: string]: string
}

export interface ConfigUrl {
  [key: string]: string
}

export interface User {
  _id?: string
  OrgInfo?: {
    hasProOrg?: boolean
    orgId?: string
  }
}

export interface GlobalConfig {
  locales: I18nKey
  lang: Lang
  configUrl: ConfigUrl
  user: User
}

export const getGlobalConfig = () => {
  const el = document.getElementById('global-config')

  let dataset = {}
  if (el) {
    try {
      dataset = JSON.parse(el.dataset.config)
    } catch (error) {
      console.error(error)
    }
  }
  return dataset as GlobalConfig
}

export const imageLang: Lang = getGlobalConfig().lang === 'en' ? 'en' : 'zh'
export const isLoginIn: boolean = getGlobalConfig().user && getGlobalConfig().user._id ? true : false
export const hasProOrg: boolean = getGlobalConfig().user && getGlobalConfig().user.OrgInfo.hasProOrg ? true : false
export const orgId: string = getGlobalConfig().user && getGlobalConfig().user.OrgInfo.orgId ? getGlobalConfig().user.OrgInfo.orgId : ''
